import { Injectable, OnDestroy, Inject } from '@angular/core';
import { ContextService } from '../modules/context/context.service';
import { IContextContactInfo } from '@ext-interfaces/context.model';
import { BehaviorSubject, Subscription, Observable } from 'rxjs';
import { ApiService } from '@app/core/services';
import { ADD_CONTACT_ROUTE } from '@ext-interfaces/app-data.model';
import { take } from 'rxjs/operators';
import { IContactSchema } from 'common-lib';
import { CONTEXT_TOKEN } from '../modules/context/context.module';
@Injectable({
    providedIn: 'root'
})
export class ContactService implements OnDestroy {
    public readonly contact: BehaviorSubject<IContextContactInfo | undefined> = new BehaviorSubject(undefined);
    private subscriptions: Subscription = new Subscription();

    constructor(@Inject(CONTEXT_TOKEN) private contextService: ContextService, private apiService: ApiService) {
        this.subscriptions.add(
            contextService.$contactInfo.subscribe((contactInContext?: IContextContactInfo) => {
                this.contact.next(contactInContext);
            })
        );
    }

    public addContact(email: string, name = '') {
        const payload: {
            name?: string;
            title?: string;
            organization?: string;
            email: string[];
            defaultEmail?: string;
            telephone?: string;
        } = { email: [email], name };

        const apiPromise = this.apiService.post(ADD_CONTACT_ROUTE, payload).pipe(take(1)).toPromise();

        return apiPromise as Promise<IContactSchema>;
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}
